import { render } from "./MainDeliveryMan.vue?vue&type=template&id=31435d01"
import script from "./MainDeliveryMan.vue?vue&type=script&lang=js"
export * from "./MainDeliveryMan.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__